import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '../../app/api/apiSlice'

const userWinsAdapter = createEntityAdapter({})

const initialState = userWinsAdapter.getInitialState()

export const userWinsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserWins: builder.query({
            query: () => ({
                url: '/userWins/getUserWins',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedUserWins = responseData.map(userWin => {
                    userWin.id = userWin._id
                    return userWin
                })
                return userWinsAdapter.setAll(initialState, loadedUserWins)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'UserWin', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'UserWin', id}))
                    ]
                } else {
                    return [ { type: 'UserWin', id: 'LIST'}]
                }
            },
        }),
        createNewUserWin: builder.mutation({
            query: initialUserWin => ({
                url: '/userWins/createNewUserWin',
                method: 'POST',
                body: {...initialUserWin,}
            }),
            invalidatesTags: [
                { type: 'UserWin', id: "LIST" }
            ] 
        }),
        updateUserWin: builder.mutation({
            query: initialUserWin => ({
                url: '/userWins/updateUserWin',
                method: 'PATCH',
                body: {...initialUserWin,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'UserWin', id: arg.id },
                { type: 'UserWin', id: 'LIST' }
            ],
        }),
        deleteUserWin: builder.mutation({
            query: ({id}) => ({
                url: '/userWins/deleteUserWin',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserWin', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetUserWinsQuery,
    useCreateNewUserWinMutation,
    useUpdateUserWinMutation,
    useDeleteUserWinMutation,
} = userWinsApiSlice

// returns the query result object
export const selectUserWinResult = userWinsApiSlice.endpoints.getUserWins.select()

// create memoized selector
const selectUserWinsData = createSelector(
    selectUserWinResult,
    userWinResult => userWinResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserWins,
    selectById: selectUserWinById,
    selectIds: selectUserWinIds,
} = userWinsAdapter.getSelectors(state => selectUserWinsData(state) ?? initialState)